// Module
var code = " <div class=\"form-group\"> <label for=\"{{propertyName}}\" ng-class=\"{'ng-required': isRequired}\" class=\"control-label\">{{label}}</label> <amt-checkbox name=\"{{propertyName}}\" ng-model=\"filterItem.value\" true-value=\"true\" false-value=\"false\" is-disabled=\"isDisabled\" is-required=\"isRequired\"> </amt-checkbox> </div>";
// Exports
module.exports = code;